import { render, staticRenderFns } from "./FeedBackModal.vue?vue&type=template&id=06aaab96"
import script from "./FeedBackModal.vue?vue&type=script&lang=js"
export * from "./FeedBackModal.vue?vue&type=script&lang=js"
import style0 from "./FeedBackModal.vue?vue&type=style&index=0&id=06aaab96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports